// Import images for bar items
import VapeImg from '../assetts/icons/warring.png';
import HookahImg from '../assetts/icons/коля.jpg';
import EnergyDrinkImg from '../assetts/icons/drink.jpg';

const barItems = [
  {
    title: 'Кальяны!',
    description: 'Новинка! Вкус и аромат в каждом кальяне!',
    items: [
      { name: 'Кальян с фруктами', price: '' },
      { name: 'Классический кальян', price: '' },
      { name: 'Кальян с ментолом', price: '' },
      { name: 'Кальян с ягодами', price: '' },
      { name: 'Кальян с цитрусом', price: '' },
    ],
    image: HookahImg,
  },
  {
    title: 'Правила клуба',
    description:
      'Пожалуйста, соблюдайте правила, чтобы каждый мог насладиться временем в нашем ',
    rules: [
      'PlayStation-клубе.',
      'Курение разрешено только в специально отведённых местах и в установленное время.',
      'Уважайте других гостей и персонал клуба, избегайте шума и агрессивного поведения.',
      'Поддерживайте чистоту и порядок на игровых местах и в зонах отдыха.',
      'Деликатно обращайтесь с оборудованием и сообщайте о любых неполадках персоналу.',
    ],
    image: VapeImg,
  },
  {
    title: 'Напитки',
    description: 'Разнообразие освежающих напитков.',
    items: [
      { name: 'Coca-Cola', price: '' },
      { name: 'Fanta', price: '' },
      { name: 'Sprite', price: '' },
      { name: 'Piko Pulpy', price: '' },
      { name: 'FuseTea', price: '' },
      { name: 'Bonaqua', price: '' },
    ],
    image: EnergyDrinkImg,
  },
];

export default barItems;
